module.exports = __webpack_public_path__ + "static/media/melai.af9e8a47.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/squadImg/melai.jpg
// module id = 739
// module chunks = 0